import React, { useState } from 'react';
import { useHistory } from 'react-router';

import * as paths from 'app-router/paths';
import { useStore } from 'stores';
import { SimpleInlineHelp } from 'components/InlineHelp';

export interface UserInputDictionary
{
  [key: string]: string,
}

interface Props
{
  userInput: UserInputDictionary,
  saveUserInput: (input: UserInputDictionary) => void,
}

export const CreateForm: React.FC<Props> = ({userInput, saveUserInput}: Props) =>
{
  const [name, setName] = useState(userInput['name'] || '');
  const [path, setPath] = useState(userInput['path'] || '');
  const history = useHistory();

  const { uiStore, requesterStore } = useStore();
  const createRequesterHandler = async () =>
  {
    saveUserInput({"name": name, "path": path});
    await requesterStore.createAsync(name, path);
    if (!requesterStore.requester.isError)
    {
      const requesterToken = requesterStore.requester.data?.token || '';
      history.push(paths.buildRequesterViewPath(requesterToken));
    }
  };
  const cancelHandler = () =>
  {
    requesterStore.requester.clearError();
    history.goBack();
  };
  return (
    <>
      <div className="fields">
        <label>
          {uiStore.labels.common.forms.requester.name.label}:
          <input type="text" placeholder={uiStore.labels.common.forms.requester.name.placeholder} value={name} onChange={e => setName(e.target.value)} />
        </label>
        <label>
          {uiStore.labels.common.forms.requester.path.label}:<SimpleInlineHelp>{uiStore.labels.help.audience.requesters.path.about}</SimpleInlineHelp>
          <input type="text" placeholder={uiStore.labels.common.forms.requester.path.placeholder} value={path} onChange={e => setPath(e.target.value)} />
        </label>
      </div>

      <div className="actions">
        <button onClick={createRequesterHandler}>{uiStore.labels.common.forms.create}</button>
        <button onClick={cancelHandler}>{uiStore.labels.common.forms.cancel}</button>
      </div>
    </>
  );
}